import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ProductoFrecuenciaCuotaService } from "../../../../_services/producto-frecuencia-cuota.service";
import { ProductoFrecuencia } from "../../../../_models/producto-frecuencia";
import { ProductoFrecuenciaCuota } from "../../../../_models/producto-frecuencia-cuota";
import { NavService } from "../../../../_services/_nav.service";
import { forkJoin } from "rxjs";

@Component({
  selector: "app-frecuencias-cuotas",
  templateUrl: "./frecuencias-cuotas.component.html",
  styleUrls: ["./frecuencias-cuotas.component.css"],
})
export class FrecuenciasCuotasComponent implements OnInit {
  @Input() productoFrecuencia: ProductoFrecuencia;
  @Input() esDetalle: boolean;
  @Output() dismiss: EventEmitter<boolean> = new EventEmitter();
  @Output() centrar: EventEmitter<boolean> = new EventEmitter();

  carInformacionInicial = true;
  submitted = false;
  formulario: FormGroup;
  lisProductosFrecuenciasCuotas: ProductoFrecuenciaCuota[] = [];
  columnas: any[];
  numeroCuotasExiste = false;

  constructor(
    private formBuilder: FormBuilder,
    private navServicio: NavService,
    private productoFrecuenciaCuotaService: ProductoFrecuenciaCuotaService
  ) {}

  ngOnInit() {
    this.setearColumnas();
    this.cargaInicial();
  }

  /* carga inicial de datos */
  cargaInicial() {
    this.lisProductosFrecuenciasCuotas = [];
    forkJoin(
      this.productoFrecuenciaCuotaService.listadoProductoFrecuenciaHabilitados(
        this.productoFrecuencia.idProductoFrecuencia
      )
    ).subscribe(([productosFrecuenciasCuotas]) => {
      this.lisProductosFrecuenciasCuotas = productosFrecuenciasCuotas;
      this.lisProductosFrecuenciasCuotas.sort(function (o1, o2) {
        if (o1.numeroCuotas > o2.numeroCuotas) {
          return 1;
        } else if (o1.numeroCuotas < o2.numeroCuotas) {
          return -1;
        }
        return 0;
      });
      this.cargarFormulario();
      this.carInformacionInicial = false;
      this.centrar.emit(true);
    });
  }

  /* columnas del data table */
  setearColumnas() {
    this.columnas = [
      {
        field: "idProductoFrecuenciaCuota",
        header: this.navServicio.buscarMensaje("LBL_ID"),
        sort: true,
      },
      {
        field: "numeroCuotas",
        header: this.navServicio.buscarMensaje(
          "PRODUCTOFRECUENCIA.LBL_NUMEROCUOTAS"
        ),
        sort: true,
      },
      {
        field: "acciones",
        header: this.navServicio.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];
  }

  /* incializar el formulario */
  cargarFormulario() {
    this.formulario = this.formBuilder.group({
      idProductoFrecuencia: [
        this.productoFrecuencia
          ? this.productoFrecuencia.idProductoFrecuencia
          : null,
        [Validators.required],
      ],
      numeroCuotas: [null, [Validators.required]],
      indicadorHabilitado: [true, [Validators.required]],
    });
  }

  onSubmit() {
    this.submitted = true;
    if (
      this.lisProductosFrecuenciasCuotas.find(
        (x) => x.numeroCuotas === this.f.numeroCuotas.value
      )
    ) {
      this.numeroCuotasExiste = true;
      return;
    } else {
      this.numeroCuotasExiste = false;
    }
    if (this.formulario.valid) {
      this.carInformacionInicial = true;
      const productoFrecuenciaCuota: ProductoFrecuenciaCuota = this.formulario
        .value;
      this.productoFrecuenciaCuotaService
        .crear(productoFrecuenciaCuota)
        .subscribe(
          (res) => {
            this.navServicio.setMesage(1);
            this.formulario.reset();
            this.submitted = false;
            this.cargaInicial();
          },
          (error) => {
            this.navServicio.setMesage(3);
            this.formulario.reset();
            this.submitted = false;
            this.carInformacionInicial = false;
          }
        );
    }
  }

  inhabilitar(row: ProductoFrecuenciaCuota) {
    row.indicadorHabilitado = false;
    this.carInformacionInicial = true;
    this.productoFrecuenciaCuotaService.actualizar(row).subscribe(
      (res) => {
        this.navServicio.setMesage(2);
        this.formulario.reset();
        this.submitted = false;
        this.cargaInicial();
      },
      (error) => {
        this.navServicio.setMesage(3);
        this.formulario.reset();
        this.submitted = false;
        this.carInformacionInicial = false;
      }
    );
  }

  get f() {
    return this.formulario.controls;
  }

  cerrar() {
    this.dismiss.emit(true);
  }
}
